import React, { memo, useContext, useEffect, useRef, useState } from "react";
import { CommonFormContext } from "../MainComponent/MainComponent";
import DorpDownSvg from "../DorpDownSvg/DorpDownSvg";

interface SelectFilterFieldProps {
  field: any;
  dropdownSelectedValue: any;
  inputError: any;
  showErrors: any;
  getDropdownData: any[];
  onKeyDown: (event: any) => void;
  removeErrors: (id: string) => void;
}

interface DropdownOption {
  label?: string;
  value?: string;
  [key: string]: any;
}

const SelectFilterField: React.FC<SelectFilterFieldProps> = ({
  field,
  dropdownSelectedValue,
  inputError,
  showErrors,
  getDropdownData = [],
  onKeyDown,
  removeErrors,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(field.value || "");
  const dropdownRef = useRef<HTMLDivElement>(null);
  const handleToggle = () => {
    if (!field?.disabled) {
      setIsOpen((prev) => !prev);
    }
  };
  const context = useContext(CommonFormContext);
  const arrowStyles = {
    marginLeft: "8px",
    transition: "transform 0.3s ease",
    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
    cursor: "pointer",
  };

  const handleOptionClick = (e: any, option: DropdownOption) => {
    if (!field?.disabled) {
      e.stopPropagation();
      removeErrors(field?.id);
      setSelectedValue(option?.label ?? option);
      setIsOpen(false);
      context.handleClick
        ? context.handleClick(option, field?.properties?.onClick, option)
        : () => {};
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  return (
    <div
      className={field.className}
      style={{ ...field?.style }}
      ref={dropdownRef}
    >
      <div style={{ position: "relative" }}>
        <div
          id={field.id}
          onClick={handleToggle}
          style={field?.properties?.mainContainerStyle}
          onKeyDown={onKeyDown}
        >
          <span>
            {dropdownSelectedValue ||
              selectedValue ||
              field?.label ||
              "Select option"}
          </span>
          <DorpDownSvg
            style={arrowStyles}
            arrowStyles={field?.properties?.arrowStyles}
          />
        </div>
        {isOpen && (
          <div
            style={{
              ...field?.properties?.dropdownStyles,
            }}
            id={field.id}
          >
            
            {getDropdownData?.map((option: any, index: number) => (
              <div
                key={option?.value ?? option}
                style={{
                  ...field?.properties?.optionStyles,
                }}
                className={`dropdown-option ${field?.fieldKey}_${index} ${
                  index === 0 ? field?.fieldKey + "_first" : ""
                } ${
                  index === getDropdownData.length - 1
                    ? field?.fieldKey + "_last"
                    : ""
                } `}
                onClick={(e) => handleOptionClick(e, option)}
              >
                {option?.label ?? (option?.area ?? option)}
              </div>
            ))}
          </div>
        )}
      </div>
      {showErrors && (
        <label
          style={{
            color: "#F04438",
            fontSize: "12px",
            ...field.errorMessageStyle,
          }}
        >
          {inputError}
        </label>
      )}
    </div>
  );
};

export default memo(SelectFilterField);
